module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAVUlEQVQokWNkYGBg2LBx038GEgELEpuRBH3/mUi1CZuNJDkXppEUZ1JkIyMLugARmv4zMDAwUCVw4KaRqpGkAEK3kZCtcMOxacRlO4qBuDSSnHaJBgBYMQs//ljF/wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/customPage/assets/images/funnel.png
// module id = lmmP
// module chunks = 65